import { render } from "./home.vue?vue&type=template&id=81be303c"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=81be303c&lang=scss"
script.render = render

export default script